import findDuplicateAssociation from 'utils/find-duplicate-association.js';
import groupApptByDate from 'utils/group-appts-by-date.js';

angular
  .module('inkfinder')
  .controller(
    'AppointmentAddWorkflowController',
    function AppointmentAddWorkflowController(
      $state,
      filterFilter,
      StyleFactory,
      Project,
      Projects,
      Appointments,
      Artists,
      Collector,
      Appointment,
      FormatAppointment,
      MergeProjects,
      AppointmentAddFactory,
      Association,
      NOTIFICATIONS,
      AlertMessages,
      Notification,
      InvitationFactory,
      Session,
      moment,
      _
    ) {
      let vm = this;

      // Public Functions
      vm.searchCollectors = searchCollectors;
      vm.selectCollector = selectCollector;
      vm.createCollector = createCollector;
      vm.startOver = startOver;
      vm.saveProject = saveProject;
      vm.session = Session;
      startOver(); // Reset everything
      getOptions(); // Get options for the creation project function

      /**
   * @name searchCollectors
   * @description Search for a collector by searching collector object phone and
   * email fields
   * @param {object} query The search criteria
   */
      function searchCollectors(query) {
        let searchFields = 'phone,email';
        Collector.searchCollectors(query, searchFields).then(function(
          collectors
        ) {
          vm.collectors = collectors;
          $state.go('inkfinder.appointments.add.collector-select');
        });
      }

      /**
   * @name createCollector
   * @description Create a collector
   * @param {object} form The entire form object
   */
      function createCollector() {
        Collector.createCollector(vm.newCollector).then(
          function(collector) {
            sendInvitation(collector);
          },
          function() {
            vm.createCollectorForm.$submitted = false;
          }
        );
      }

      /**
   * @name sendInvitation
   * @description Function to send invitation after a collector is created.
   * @param {type} collector The collector to send the invitation to
   */
      function sendInvitation(collector) {
        let id = collector.id;
        Collector.getCollector(id).then(function(collector) {
          vm.selectedCollector = collector;

          /**
       * @name createInvitation
       * @description Define the function to create invitations and define
       * the invitation object
       * @param {type} association Description
       * @return {type} Description
       */
          function createInvitation(association) {
            let invitation = {
              collectorId: association.collector.id,
              shopId: association.shop.id,
              associationId: association.id
            };
            return InvitationFactory.createInvitation(invitation);
          }

          /**
       * @name sendNotification
       * @description Define the function to send notifications and define
       * the notification object
       * @param {type} invitation Description
       */
          function sendNotification(invitation) {
            let notification = {
              recipients: [invitation.collector.id],
              notificationId: NOTIFICATIONS.collectorWelcome,
              messageObjects: {
                invitationId: invitation.id,
                // The logged in artist or operator
                operatorId: Session.collector.id
              },
              messageVariables: {
                subject:
                  invitation.collector.first_name +
                  ', ' +
                  vm.session.collector.first_name +
                  ' ' +
                  vm.session.collector.last_name +
                  ' invited you to collaborate on Ink Finder'
              }
            };
            if (vm.session.activeState.association.shop.id) {
              notification.messageObjects.shopId =
                vm.session.activeState.association.shop.id;
              notification.messageVariables.subject =
                vm.selectedCollector.first_name +
                ', ' +
                vm.session.collector.first_name +
                ' ' +
                vm.session.collector.last_name +
                ' at ' +
                vm.session.activeState.association.shop.name +
                ' invited you to collaborate on Ink Finder';
            }
            Notification.send(notification);
          }

          // Must create a new association
          let type = 'Collector';
          let _association = {
            collector_id: collector.id,
            shop_id: vm.session.activeState.association.shop.id,
            status: 'Shop Invited',
            startDatetime: moment().format('YYYY-MM-DDTHH:mm:ss'),
            endDatetime: null,
            can_update_appts: true
          };
          Association.createAssociation(type, _association)
            .then(createInvitation)
            .then(sendNotification)
            .catch(function(_association) {
              AlertMessages.add({
                msg:
                  'We tried to save this invitation, but something failed. Please try again.',
                type: 'danger'
              });
            });
          $state.go('inkfinder.appointments.add.project-create');
        });
      }

      /**
   * @name selectCollector
   * @description Select a collector and return any appointments for this shop.
   * @param {object} collector The collector to select.
   */
      function selectCollector(collector) {
        vm.selectedCollector = collector;

        /**
     * @name createInvitation
     * @description Define the function to create invitations and define the
     * invitation object
     * @param {type} association Description
     * @return {type} Description
     */
        function createInvitation(association) {
          let invitation = {
            collectorId: association.collector.id,
            shopId: association.shop.id,
            associationId: association.id
          };
          return InvitationFactory.createInvitation(invitation);
        }

        /**
     * @name sendNotification
     * @description Define the function to send notifications and define the
     * notification object
     * @param {type} invitation Description
     */
        function sendNotification(invitation) {
          let notification = {
            recipients: [invitation.collector.id],
            notificationId: NOTIFICATIONS.collectorWelcome,
            messageObjects: {
              invitationId: invitation.id,
              operatorId: Session.collector.id // The logged in artist or operator
            },
            messageVariables: {
              subject:
                invitation.collector.first_name +
                ', ' +
                vm.session.collector.first_name +
                ' ' +
                vm.session.collector.last_name +
                ' invited you to collaborate on Ink Finder'
            }
          };
          if (vm.session.activeState.association.shop.id) {
            notification.messageObjects.shopId =
              vm.session.activeState.association.shop.id;
            notification.messageVariables.subject =
              vm.selectedCollector.first_name +
              ', ' +
              vm.session.collector.first_name +
              ' ' +
              vm.session.collector.last_name +
              ' at ' +
              vm.session.activeState.association.shop.name +
              ' invited you to collaborate on Ink Finder';
          }
          Notification.send(notification);
        }

        // Check for duplicate associations for this shop and collector
        let shopToCheck = Session.activeState.association.shop.id;
        let typeToCheck = 'Collector';
        let duplicateAssociations = findDuplicateAssociation(
          vm.selectedCollector.associations,
          shopToCheck,
          typeToCheck
        );
        if (!duplicateAssociations) {
          // Must create a new association
          let type = 'Collector';
          let _association = {
            collector_id: vm.selectedCollector.id,
            shop_id: vm.session.activeState.association.shop.id,
            status: 'Shop Invited',
            startDatetime: moment().format('YYYY-MM-DDTHH:mm:ss'),
            endDatetime: null,
            can_update_appts: true
          };
          Association.createAssociation(type, _association)
            .then(createInvitation)
            .then(sendNotification)
            .catch(function(_association) {
              AlertMessages.add({
                msg:
                  'We tried to save this invitation, but something failed. Please try again.',
                type: 'danger'
              });
            });
        }

        let search = false;
        let start;
        let end;
        let timestamp;
        let artist;
        Appointments.get(
          search,
          start,
          end,
          timestamp,
          artist,
          vm.selectedCollector.id
        ).then(function(appointments) {
          if (appointments.length > 0) {
            MergeProjects.merge(appointments).then(function(mergedData) {
              vm.collectorAppointments = groupApptByDate(mergedData);
              // If the selected collector has projects, go to project select.
              // If not, go to project create.
              $state.go('inkfinder.appointments.add.project-select');
            });
          } else {
            // Get options for the creation project function
            getOptions();
            $state.go('inkfinder.appointments.add.project-create');
          }
        });
      }

      /**
   * @description Select the Size
   */
      vm.process_size = function() {
        vm.newProject.size = filterFilter(vm.options.sizes, {
          id: vm.selected_options.size
        })[0];
      };

      /**
   * @name getOptions
   * @description Get the Size/Placement/Area/Style Options
   */
      function getOptions() {
        Project.getOptions().then(function(options) {
          vm.options = options;
        });

        StyleFactory.getStyles().then(function(styles) {
          vm.styles = styles;
        });
      }

      /**
   * @name saveProject
   * @description Function to create a new project.
   * @param {object} newProject The project to be created.
   */
      function saveProject(newProject) {
        vm.data = {};
        // Assemble the missing Project Data
        newProject.collector = vm.selectedCollector.id;
        newProject.referenceImages = vm.referenceImages;
        newProject.coverupImages = vm.coverupImages;
        Project.create(newProject)
          .then(function(project) {
            vm.data.project = project;
            let newAppointment = {
              project_id: project.id
            };
            return Appointment.create(newAppointment);
          })
          .then(function(appointment) {
            vm.data.appointment = appointment;
            AppointmentAddFactory.data = vm.data;

            // Send a notification to the collector when a project is created.
            let notification = {
              recipients: [vm.selectedCollector.id],
              notificationId: NOTIFICATIONS.projectCreated,
              messageObjects: {
                // The collector that created the project
                collectorId: vm.session.collector.id,
                projectId: vm.data.project.id
              },
              messageVariables: {
                subject:
                  vm.selectedCollector.first_name +
                  ', ' +
                  vm.session.collector.first_name +
                  ' ' +
                  vm.session.collector.last_name +
                  ' started a project for you on Ink Finder'
              }
            };
            if (vm.session.activeState.association.shop.id) {
              notification.messageObjects.shopId =
                vm.session.activeState.association.shop.id;
              notification.messageVariables.subject =
                vm.selectedCollector.first_name +
                ', ' +
                vm.session.collector.first_name +
                ' ' +
                vm.session.collector.last_name +
                ' at ' +
                vm.session.activeState.association.shop.name +
                ' started a project for you on Ink Finder';
            }
            Notification.send(notification);
            $state.go('inkfinder.appointments.add.update');
          })
          .catch(function(error) {
            // Error handling for project and appointment create goes here
          });
      }

      /**
   * @name startOver
   * @description Reset any data retrieved or saved in the add artist workflow
   * @param {boolean} transition Boolean to determine if the function should
   * change state to the starting point.
   */
      function startOver(transition) {
        // Collectors
        vm.collectors = [];
        vm.selectedCollector = {};
        vm.newCollector = {};
        vm.collectorAppointments = {};

        // Projects
        vm.newProject = {};
        vm.referenceImages = [];
        vm.coverupImages = [];
        vm.project = {}; // Result after submitting Project

        if (transition) {
          $state.go('inkfinder.appointments.add.collector');
        }
      }

      // Call the startOver function if a collector hasn't been selected later on
      // in the process
      if (!vm.selectedCollector.length) {
        startOver(true);
      }
      return vm;
    }
  );



// WEBPACK FOOTER //
// ./components/appointments/add/appointment-add-workflow.controller.js